module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/Bitmap_basketball-d642abfe5da80b34ddb8fb084c9e718f.svg";